import { render, staticRenderFns } from "./BroadcastSettings.vue?vue&type=template&id=8a160f00&"
import script from "./BroadcastSettings.vue?vue&type=script&lang=js&"
export * from "./BroadcastSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports